module.exports = __webpack_public_path__ + "static/media/check.1fb62aac.png";